var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ztd-status bt-d-inline-block",class:_vm.type},[_c('h4',{staticClass:"trim-text ff-aeonik-medium font-weight-normal bt-d-flex bt-align-items-center"},[_vm._t("default",[_vm._v("Status")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }